export enum TipoDespachoEnum {
   NotSet = 0,
   Receptor = 1,
   EmisorACliente = 2,
   EmisorAOtrasInstalaciones = 3,
}
